export default (bytes, dec) => {
	const units = ["b", "KB", "MB", "GB", "TB"],
		len = units.length;
	let i = 0;
	for (; bytes >= 1024 && i < len; i += 1) {
		bytes /= 1024;
	}
	return bytes.toFixed(i === 0 ? 0 : dec) + units[i];
}
